var _rect, _rect2, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaymentTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 36,
    height: 36,
    rx: 18,
    fill: "#E0E2E7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 36,
    height: 36,
    rx: 18,
    stroke: "#F0F1F3",
    strokeWidth: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.9666 20.6975C24.3519 20.3017 24.3433 19.6686 23.9475 19.2834C23.5517 18.8982 22.9186 18.9068 22.5334 19.3025L19.2737 22.6517L17.8755 21.5309C17.4446 21.1854 16.8152 21.2547 16.4698 21.6856C16.1244 22.1166 16.1936 22.7459 16.6246 23.0914L19.0857 25.0643C19.2867 25.2254 19.5771 25.2075 19.7567 25.0229L23.9666 20.6975Z",
    fill: "#667085"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 10C16.5523 10 17 10.4477 17 11H23C23 10.4477 23.4477 10 24 10C24.5523 10 25 10.4477 25 11H26C27.6569 11 29 12.3431 29 14V27C29 28.6569 27.6569 30 26 30H14C12.3431 30 11 28.6569 11 27V14C11 12.3431 12.3431 11 14 11H15C15 10.4477 15.4477 10 16 10ZM27 14V15H13V14C13 13.4477 13.4477 13 14 13H15C15 13.5523 15.4477 14 16 14C16.5523 14 17 13.5523 17 13H23C23 13.5523 23.4477 14 24 14C24.5523 14 25 13.5523 25 13H26C26.5523 13 27 13.4477 27 14ZM13 27V17H27V27C27 27.5523 26.5523 28 26 28H14C13.4477 28 13 27.5523 13 27Z",
    fill: "#667085"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentTime);
export default __webpack_public_path__ + "static/media/payment-time.31269d8dc27b7e04a729801452247813.svg";
export { ForwardRef as ReactComponent };